import React from "react";

export const AppFooter = (props) => {
    return (
        <div className="layout-footer">
            <img src={props.layoutColorMode === "light" ? "https://csticorp.biz/wp-content/uploads/2019/05/Logo-CSTI-8.png" : "assets/layout/images/logo-white.svg"} alt="Logo" height="20" className="mr-2" />
            by
            <span className="font-medium ml-2">CSTI Corp</span>
        </div>
    );
};
